import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';

export const DefaultShipping = ({ alertType, shippingMessage }) => {
  return (
    <Alert
      type={alertType}
      message={shippingMessage}
      inline
    />
  );
};

DefaultShipping.propTypes = {
  alertType: PropTypes.string,
  shippingMessage: PropTypes.string
};

DefaultShipping.defaultProps = {
  alertType: 'success',
  shippingMessage: 'Standard delivery',
};
